import { Icon, Button, Drawer } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSurchargePaymentData } from "../../../redux/actions/orderCard";
import moment from "moment";

class SurchargeDrawerItem extends React.Component {
  state = {
    expandVisible: false
  };

  setVisibleExpand = value => {
    this.setState({ expandVisible: value });
  };

  render() {
    const data = this.props.data;
    const { setVisibleExpand } = this;
    return (
      <div className="drawer-main__item drawer-main-item">
        <div className="drawer-main-item__main-text">
          <span className="drawer-main-item__text">
            {data.name} : {data.difference}
            {data.expands &&
            data.expands.length &&
            !this.state.expandVisible ? (
              <Button
                type="link"
                onClick={() => {
                  setVisibleExpand(true);
                }}
              >
                Подробнее о тарифах <Icon type="down" />
              </Button>
            ) : null}
          </span>
          <span className="drawer-main-item__tariff">{data.tariff}</span>
        </div>
        <div className="drawer-main-item__price-info">
          <span className="drawer-main-item__price-comment">
            (НДС {!data.nds && `не`} облагается){" "}
          </span>
          <span className="drawer-main-item__price">{data.total} ₽</span>
        </div>

        {data.expands && data.expands.length && this.state.expandVisible ? (
          <div className="drawer-main-item__collapse collapse">
            {data.expands.map(item => (
              <div className="collapse__item">
                <span className="collapse__item-text">{item.phrase}</span>
              </div>
            ))}
            <Button
              type="link"
              onClick={() => {
                setVisibleExpand(false);
              }}
            >
              Скрыть <Icon type="up" />
            </Button>
          </div>
        ) : null}
      </div>
    );
  }
}

const OrderSurcharge = props => {
  const { order } = props;
  const dispatch = useDispatch();
  const surchargeData = useSelector(
    state => state.Executorship.Orders.orderCard.surchargePaymentData
  );
  const [showingDrawer, setShowingDrawer] = useState(false);
  useEffect(() => {
    dispatch(getSurchargePaymentData(order.id));
  }, [order]);

  const drawerElements =
    surchargeData &&
    surchargeData.data &&
    Object.keys(surchargeData.data).map(item => {
      return (
        <SurchargeDrawerItem
          data={{ ...surchargeData.data[item] }}
          key={item}
        />
      );
    });

  return (
    <>
      {surchargeData && surchargeData.meta && surchargeData.meta.total > 0 && (
        <div className="line-content__row">
          <div className="line-content__column">
            <Button
              className="line-content__link"
              onClick={() => {
                setShowingDrawer(true);
              }}
              type="link"
              style={{ textAlign: "left" }}
            >
              Доплата
            </Button>
          </div>
          <div className="line-content__column">
            <span className="line-content__additional">
              {surchargeData.meta.total > 0
                ? `${surchargeData.meta.total} ₽`
                : null}
            </span>
          </div>
        </div>
      )}
      <Drawer
        visible={showingDrawer}
        onClose={() => {
          setShowingDrawer(false);
        }}
        destroyOnClose={true}
        placement={"left"}
        width={896}
        className={"order-surcharge-drawer"}
      >
        <div className={"drawer-header"}>
          <span className={"drawer-header__title"}>Доплаты по заказу</span>
          <span className={"drawer-header__number"}>
            Заказ - {order && order.number}
            {/*// getNumberWithoutSpaces(this.props.order.number)}*/}
          </span>
        </div>

        <div className="basicForm">
          <div className="drawer-main">{drawerElements}</div>
        </div>
        <div className={"drawer-footer"}>
          {surchargeData && surchargeData.meta ? (
            <>
              <div className="drawer-footer__surcharge-summ">
                <div className="drawer-footer__surcharge-summ-item">
                  <div className="drawer-footer__surcharge-summ-text">
                    Сумма доплат без НДС
                  </div>
                  <div className="drawer-footer__surcharge-summ-digit">
                    {surchargeData.meta.total_without_nds} ₽
                  </div>
                </div>
                <div className="drawer-footer__surcharge-summ-item">
                  <div className="drawer-footer__surcharge-summ-text">
                    Сумма доплат c НДС
                  </div>
                  <div className="drawer-footer__surcharge-summ-digit">
                    {surchargeData.meta.total_nds} ₽
                  </div>
                </div>
                <div className="drawer-footer__surcharge-summ-total">
                  <div className="drawer-footer__surcharge-summ-total-item">
                    Общаяя сумма: {surchargeData.meta.total_nds_part_money}₽
                  </div>
                  <div className="drawer-footer__surcharge-summ-total-item">
                    НДС 20%: {surchargeData.meta.total_nds_part_money_percent}
                  </div>
                </div>
              </div>
              <div className="drawer-footer__surcharge-total">
                <div className="drawer-footer__surcharge-total-text">
                  <div className="drawer-footer__surcharge-total-text-main">
                    Итого к доплате:
                  </div>
                  <div className="drawer-footer__surcharge-total-text-sub">
                    Способ доплаты — {surchargeData.meta.payment_type}
                  </div>
                </div>
                <div className="drawer-footer__surcharge-total-digit">
                  {surchargeData.meta.total} ₽
                </div>
              </div>
              <div className="drawer-footer__surcharge-time">
                <div className="drawer-footer__surcharge-time-item">
                  <div className="drawer-footer__surcharge-time-text">
                    Срок оплаты компенсации в случае одностороннего отказа
                  </div>
                  <div className="drawer-footer__surcharge-time-date">
                    {surchargeData.meta.kp1rc_datetime &&
                      moment(surchargeData.meta.kp1rc_datetime).format(
                        "DD.MM.YYYY, HH:mm"
                      )}
                  </div>
                </div>
                <div className="drawer-footer__surcharge-time-item">
                  <div className="drawer-footer__surcharge-time-text">
                    Срок оплаты дополнительных платежей
                  </div>
                  <div className="drawer-footer__surcharge-time-date">
                    {surchargeData.meta.payment_time_add &&
                      surchargeData.meta.payment_time_add.date &&
                      moment(surchargeData.meta.payment_time_add.date).format(
                        "DD.MM.YYYY, HH:mm"
                      )}
                  </div>
                </div>
                <div className="drawer-footer__surcharge-time-item">
                  <div className="drawer-footer__surcharge-time-text">
                    Срок возврата фрахтовщиком в случае отказа от заказа
                  </div>
                  <div className="drawer-footer__surcharge-time-date">
                    {surchargeData.meta.return_time &&
                      surchargeData.meta.return_time.date &&
                      moment(surchargeData.meta.return_time.date).format(
                        "DD.MM.YYYY, HH:mm"
                      )}
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </Drawer>
    </>
  );
};

export default OrderSurcharge;
